(function () {
  function init(root) {
    root.querySelectorAll('[data-everclear-story-video]').forEach(function (video) {
      if (video.dataset.initialized) return;
      video.dataset.initialized = 'true';
      var inView = false;
      var userPaused = false;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      video.muted = true;

      function load() {
        if (video.hasAttribute('src')) return;
        video.poster = video.dataset.poster;
        video.src = video.dataset.src;
        video.load();
      }
      function playIfVisible() {
        if (!inView || document.hidden || reducedMotion.matches || userPaused) return;
        var play = video.play();
        if (play) play.catch(function () { /* Keep the poster visible if the browser blocks autoplay. */ });
      }
      video.addEventListener('pause', function () {
        // Preserve an intentional pause while the visitor is watching.
        if (inView && !document.hidden && !reducedMotion.matches) userPaused = true;
      });
      video.addEventListener('play', function () { userPaused = false; });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) video.pause();
        else playIfVisible();
      });
      reducedMotion.addEventListener('change', function () {
        if (reducedMotion.matches) video.pause();
        else playIfVisible();
      });

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            inView = entry.isIntersecting && entry.intersectionRatio >= 0.25;
            if (inView) {
              load();
              playIfVisible();
            } else {
              video.pause();
            }
          });
        }, { threshold: [0, 0.25] });
        observer.observe(video);
      } else {
        // Older browsers keep manual playback without an eager media download.
        video.poster = video.dataset.poster;
        video.addEventListener('pointerdown', load, { once: true });
        video.addEventListener('keydown', load, { once: true });
      }
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
